import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { createMuiTheme, ThemeProvider, withStyles } from "@material-ui/core/styles";
import { CircularProgress } from "@material-ui/core";
import axios from 'axios'

const theme = createMuiTheme({
    palette: {
        primary: {
            main: "#0b1f82"
        },
        secondary: {
            main: "#FF0000"
        }
    }
});


const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

function RenamePieceRuleDialog(props) {
    const { t } = useTranslation();

    let { onClose, handleRequestFinish, rule_piece } = props

    const [rulePieceName, setRulePieceName] = useState(rule_piece.name || '')
    const [rulePieceDescription, setRulePieceDescription] = useState(rule_piece.description || '')

    const [isLoading, setIsLoading] = useState(false)

    const validateAllValues = () => {
        return rulePieceName.length > 0 && rulePieceDescription.length > 0
    }

    const handleSaveRulePiece = () => {
        setIsLoading(true)
        let payload = {
            name: rulePieceName,
            description: rulePieceDescription
        }
        let url = '/dash/rule_engine/rule_piece/' + rule_piece.rule_piece_key
        setTimeout(function () {
            axios.put(url, payload).then(response => {
                handleRequestFinish("success", "Trecho editado com sucesso")
            }).catch(error => {
                handleRequestFinish("error", "Não foi possível editar esse trecho")
            });
        }, 500);
    }

    const handleClose = () => {
        onClose()
        setTimeout(function () {
            setRulePieceName(rule_piece.name)
            setIsLoading(false)
        }, 500);
    }

    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            disableBackdropClick
            disableEscapeKeyDown
            keepMounted={false}
        >
            <DialogTitle
                className={['blueText', "subtitleSize"].join(" ")}
                onClose={handleClose}
            >
                {t("Renomear Trecho de Regra")}
            </DialogTitle>
            <DialogContent >
                <ThemeProvider theme={theme}>
                    <div style={{ padding: "10px", display: "flex", flexDirection: "column", width: "320px", "height": "260px" }}>
                        {isLoading
                            ?
                            <CircularProgress style={{ margin: "auto" }} />
                            :
                            <React.Fragment>
                                <div className="internalCardContainer">
                                    <TextField
                                        error={!rulePieceName.length > 0}
                                        label={t("Name")}
                                        style={{ textAlign: "center" }}
                                        className="filterTextbox"
                                        size="small" fullWidth
                                        value={rulePieceName}
                                        onChange={(e) => setRulePieceName(e.target.value)}
                                        autoFocus
                                    />
                                </div>
                                <div className="internalCardContainer">
                                    <TextField
                                        error={!rulePieceDescription.length > 0}
                                        label={t("Description")}
                                        style={{ textAlign: "center" }}
                                        className="filterTextbox"
                                        size="small" fullWidth
                                        value={rulePieceDescription}
                                        onChange={(e) => setRulePieceDescription(e.target.value)}
                                        autoFocus
                                    />
                                </div>
                                <div className="internalCardContainer" style={{ display: "flex", marginTop: "30px" }}>
                                    <div
                                        className={["button", "onlyboarder", "normalText", "normalMediumSize"].join(" ")}
                                        style={{ width: "120px" }}
                                        onClick={handleClose}
                                    >
                                        {t("discard")}
                                    </div>
                                    <div
                                        className={
                                            validateAllValues()
                                                ?
                                                ["button", "standard", "normalText", "normalMediumSize"].join(" ")
                                                :
                                                ["button", "standard", "normalText", "normalMediumSize", "disabled"].join(" ")}
                                        style={{ width: "120px" }}
                                        onClick={validateAllValues() ? () => handleSaveRulePiece() : null}
                                    >
                                        {t("save")}
                                    </div>
                                </div>
                            </React.Fragment>
                        }
                    </div>
                </ThemeProvider>
            </DialogContent>
        </Dialog>
    )
}

export default RenamePieceRuleDialog